import React from 'react';
import { FaTwitter, FaLinkedinIn, FaFacebookF } from 'react-icons/fa';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="site-footer">
      <div className="footer-main">
        <div className="footer-inner">
          <div className="footer-col brand">
            <div className="brand-name">ULJAAPP</div>
            <div className="brand-sub">Universal Law and Justice App</div>
            <p>Bridging Law to Life</p>
            <p>Empowering access to justice for all.</p>
          </div>

          <div className="footer-col">
            <h4>Our Services</h4>
            <ul>
              <li><a href="/search">Find Solutions</a></li>
              <li><a href="/draft-create">Create Draft</a></li>
              <li><a href="/document-reader">Document Reader</a></li>
              <li><a href="/contribute">Contribute</a></li>
              <li><a href="/indian-law">Indian Law</a></li>
              <li><a href="/legal-advisors">Legal Advisors</a></li>
              <li><a href="/news-information">News</a></li>
              <li><a href="/articles">Publications</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              <li><a href="/about">About</a></li>
              <li><a href="/feedback">Feedback</a></li>
              <li><a href="/terms-of-service">Terms of Service</a></li>
              <li><a href="/privacy-policy">Privacy Policy</a></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <ul className="contact-list">
              <li><a href="mailto:support.uljaapp@atozasindia.in">support.uljaapp@atozasindia.in</a></li>
              {/* <li><a href="tel:+911234567890">+91 12345 67890</a></li> */}
              {/* <li className="socials">
                <a aria-label="Twitter" href="https://twitter.com" target="_blank" rel="noopener noreferrer"><FaTwitter /></a>
                <a aria-label="LinkedIn" href="https://linkedin.com" target="_blank" rel="noopener noreferrer"><FaLinkedinIn /></a>
                <a aria-label="Facebook" href="https://facebook.com" target="_blank" rel="noopener noreferrer"><FaFacebookF /></a>
              </li> */}
            </ul>
          </div>
        </div>
      </div>

      <div className="footer-bottom">© {year} ULJAAPP. All rights reserved.</div>
    </footer>
  );
};

export default Footer;
